import UserLayout from '../../layouts/UserLayout.vue'

export default {
  sort: 1,
  path: '/user',
  name: 'User',
  component: UserLayout,
  children: [
    {
      path: '',
      redirect: 'orders'
    },
    {
      path: 'orders',
      name: 'user-orders',
      component: () => import('@/views/User/order')
    },
    {
      path: 'order',
      name: 'user-order',
      component: () => import('@/views/User/orders')
    },
    {
      path: 'consulting-service',
      name: 'user-consulting-service',
      component: () => import('@/views/User/consulting-service/index'),
      redirect: '/user/consulting-service/form',
      children: [
        {
          name: 'consulting-service-records',
          path: 'records',
          meta: {
            title: '咨询记录'
          },
          component: () => import('@/views/User/consulting-service/records')
        },
        {
          name: 'consulting-service-form',
          path: 'form',
          meta: {
            title: '我要咨询'
          },
          component: () => import('@/views/User/consulting-service/form')
        }
      ]
    },
    {
      path: 'system-message',
      name: 'user-system-message',
      component: () => import('@/views/User/system-message')
    },
    {
      path: 'system-courier',
      name: 'user-system-courier',
      component: () => import('@/views/User/courier/index')
    },
    {
      path: 'template',
      name: 'user-template',
      component: () => import('@/views/User/template/index')
    },
    {
      path: 'express',
      name: 'user-express',
      component: () => import('@/views/User/express')
    },
    {
      path: 'recommend',
      name: 'user-recommend',
      component: () => import('@/views/User/recommend')
    },
    {
      path: 'submission',
      name: 'user-submission',
      component: () => import('@/views/User/submission')
    },
    {
      path: 'mailingAddress',
      name: 'user-mailingAddress',
      component: () => import('@/views/User/mailingAddress')
    },
    {
      path: 'discountCoupon',
      name: 'user-discountCoupon',
      component: () => import('@/views/User/discountCouponList')
    },
    {
      path: 'thankReward',
      name: 'thankReward',
      component: () => import('@/views/User/thankReward')
    },
    {
      path: 'appraise',
      name: 'appraise',
      component: () => import('@/views/User/appraise/index')
    },
    {
      path: 'Im',
      name: 'user-Im',
      component: () => import('@/views/User/Im')
    },
    {
      path: 'user',
      component: () => import('@/views/User/User')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/user.js